module.exports = __webpack_public_path__ + "img/goldregen_team.6ad4b842.jpg";